import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { Subject } from 'rxjs';
import { Sgke110dComponent } from '../../pages/sgke110d/sgke110d.component';

@Component({
  selector: 'app-sgke110d-dialog',
  templateUrl: './sgke110d-dialog.component.html',
  styleUrl: './sgke110d-dialog.component.scss'
})
export class Sgke110dDialogComponent implements OnInit, OnDestroy {

  @ViewChild(Sgke110dComponent) sgke110dComponent!: Sgke110dComponent;

  /** 購読を停止するためのSubject */
  private onDestroy$ = new Subject();

  /**
   * コンストラクタ
   * @param {{ 
   *           isEdit: boolean,
   *           rcvmnyNotificationreportMno: string,
   *           rcvmnyNotificationreportRrkno: string,
   *           rcvmnyReconciliationresultMno: string,
   *           rcvmnyNotificationreportUpdatesequencenumber: string,
   *           rcvmnyreconciliationResultUpdatesequencenumber: string
   *         }}data 
   * @param { MatDialogRef<Sgke110dDialogComponent>} dialogRef 
   */
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      isEdit: boolean,
      rcvmnyNotificationreportMno: string,
      rcvmnyNotificationreportRrkno: string,
      rcvmnyReconciliationresultMno: string,
      rcvmnyNotificationreportUpdatesequencenumber: string,
      rcvmnyreconciliationResultUpdatesequencenumber: string
    },
    public dialogRef: MatDialogRef<Sgke110dDialogComponent>) { }

  /**
   * 初期処理
   * @memberof Sgke110dDialogComponent
   */
  ngOnInit(): void {
  }

  /**
   * 購読解除
   * @memberof Sgke110dDialogComponent
   */
  ngOnDestroy() {
    //購読を停止する処理
    this.onDestroy$.next();
  }

  /**
   * ダイアログクローズ処理
   * @param {any} data 
   * @memberof Sgke110dDialogComponent
   */
  closeDialog(data: any) {
    this.dialogRef.close(data);
  }

}
